export default "__VITE_ASSET__CmNLXgQv__"